import { useState, useEffect, useRef, useCallback } from 'react';
import 'swiper/css';
import { useNavigate, useLocation } from 'react-router-dom';
import Dropdown from '../../Components/CustomDropdown/customdropdown';
import DropdownTest from '../../Components/CustomDropdown/ndrop';
import { useToast } from '../../Utils/toastContext';
import { changeAgencyTabFalse } from '../../Redux/store/selectedCard';
import { useSelector, useDispatch } from 'react-redux';
import { setAgencyNameRedux } from '../../Redux/store/userSlice';
import { setOnboardingCustomer } from '../../Redux/store/onboardingFormSlice';
import { debounce } from 'lodash';
import AddressAutocomplete from '../../Components/addressInput/address-input';
import countriesData from '../../Data/CountryCodes.json';
import { Ban, RotateCcw } from 'lucide-react';
import { formatDateTimeUTC } from '../../Constants/helper-functions';

const validator = require('validator');

const AgencyList = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const dispatch = useDispatch();
  const [showBlockModal, setShowBlockModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showRecords, setShowRecords] = useState(10);
  const [customers, setCustomers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, settotalPages] = useState(0);
  const [filterText, setFilterText] = useState('');
  const [totalCount, settotalCount] = useState(0);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isSendMessageOpen, setIsSendMessageOpen] = useState(false);
  const [istemplateOpen, setIstemplateOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [isNewChange, setisNewChange] = useState(true);
  const [startAmount, setStartAmount] = useState(0);
  const [endAmount, setEndAmount] = useState(0);
  const [isToUser, setToUser] = useState(false);
  const [isFileExisted, setIsFileExisted] = useState(false);
  const [file, setFile] = useState(null);
  const [newFile, setnewFile] = useState(null);
  const [currentFile, setCurrentFile] = useState(null);
  const [currentDoc, setCurrentDoc] = useState(null);
  const [isDocDelete, setIsDocDelete] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const buttonRefs = useRef({});
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [agentId, setAgentId] = useState(null);
  const roleName = useSelector((state) => state.user.roleName);
  const [loading, setLoading] = useState(false);
  const addCustomerRef = useRef();
  const [customerFirstName, setCustomerFirstName] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [selectedCode, setSelectedCode] = useState('+61');
  const [customerLastName, setCustomerLastName] = useState('');
  const [countries, setCountries] = useState([]);
  const [email, setEmail] = useState('');
  const [focus, setFocus] = useState(false);
  const [isOpenNewCustomer, setIsOpenNewCustomer] = useState(false);
  const [registeredAddress, setRegisteredAddress] = useState('');
  const [redRegCountry, setRegCountry] = useState(null);
  const [redRegCity, setRegCity] = useState(null);
  const [redRegState, setRegState] = useState(null);
  const handlePendingClick = () => {
    //  setFilter("to_review");
    setIsDropdownOpen((prevState) => !prevState); // Toggle dropdown
  };
  const handleCodeChange = (e) => {
    setSelectedCode(e.target.value);
  };
  const clearAllCustomerFields = () => {
    setCustomerFirstName('');
    setSelectedCode('+61');
    setMobileNumber('');
    setCustomerLastName('');
    setEmail('');
  };
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const togglePopupAddCustomer = () => {
    clearAllCustomerFields();
    setIsOpenNewCustomer(!isOpenNewCustomer);
  };

  const handleFileChange = (e) => {
    if (file) {
      setIsFileExisted(true);
      setCurrentFile(e.target.files[0]);
      return;
    } else {
      setnewFile(e.target.files[0]);
    }
  };
  useEffect(() => {
    updateFile();
  }, [newFile]);
  useEffect(() => {
    if (
      (registeredAddress && registeredAddress.country) ||
      (registeredAddress && registeredAddress.country.name)
    ) {
      getAllLocationDetailsReg();
    }
  }, [registeredAddress]);
  useEffect(() => {
    setCountries(countriesData);
  }, []);
  const updateFile = () => {
    const selectedFile = newFile;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (
        [
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFile(selectedFile);
      } else {
        showToast(
          'File must be doc or docx format and must be less than 10MB',
          'error',
        );

        setIsFileExisted(false);
      }
    }
  };
  const documents = [
    {
      id: 1,
      name: 'test Signature.doc',
      date: '22-01-2024 | 4.56 PM',
      size: '122.4 KB',
      icon: '/word-icon.svg',
    },
    {
      id: 2,
      name: 'Customer Signature.doc',
      date: '22-01-2024 | 4.56 PM',
      size: '122.4 KB',
      icon: '/word-icon.svg',
    },
    {
      id: 3,
      name: 'Customer Signature.doc',
      date: '22-01-2024 | 4.56 PM',
      size: '122.4 KB',
      icon: '/word-icon.svg',
    },
    {
      id: 4,
      name: 'Customer Signature.doc',
      date: '22-01-2024 | 4.56 PM',
      size: '122.4 KB',
      icon: '/word-icon.svg',
    },
    {
      id: 5,
      name: 'Customer Signature.doc',
      date: '22-01-2024 | 4.56 PM',
      size: '122.4 KB',
      icon: '/word-icon.svg',
    },
    {
      id: 6,
      name: 'Customer Signature.doc',
      date: '22-01-2024 | 4.56 PM',
      size: '122.4 KB',
      icon: '/word-icon.svg',
    },
    {
      id: 7,
      name: 'Customer Signature.doc',
      date: '22-01-2024 | 4.56 PM',
      size: '122.4 KB',
      icon: '/word-icon.svg',
    },
    {
      id: 8,
      name: 'Customer Signature.doc',
      date: '22-01-2024 | 4.56 PM',
      size: '122.4 KB',
      icon: '/word-icon.svg',
    },
    {
      id: 9,
      name: 'Customer Signature.doc',
      date: '22-01-2024 | 4.56 PM',
      size: '122.4 KB',
      icon: '/word-icon.svg',
    },
    {
      id: 10,
      name: 'Customer Signature.doc',
      date: '22-01-2024 | 4.56 PM',
      size: '122.4 KB',
      icon: '/word-icon.svg',
    },
    // Add more documents as needed
  ];

  const togglePopup = () => setIsOpen(!isOpen);
  const toggleSendMessagePopup = () => setIsSendMessageOpen(!isSendMessageOpen);
  const toggleAddTemplatePopup = () => {
    setIstemplateOpen(!istemplateOpen);
  };
  const [recipients, setRecipients] = useState([
    'Jason Quest',
    'Brian Vaughan',
  ]);
  const [suggestions] = useState([
    'Brian Vaughan',
    'Brian Edmon',
    'Colin Simpson',
  ]);
  const [inputValue, setInputValue] = useState(''); // Track the input value

  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  const [filteredSuggestions, setFilteredSuggestions] = useState(suggestions); // Store filtered suggestions
  const [showSuggestions, setShowSuggestions] = useState(false); // Control dropdown visibility

  const handleAddRecipient = (recipient) => {
    setRecipients([...recipients, recipient]);
    setInputValue(''); // Clear the input field
    setShowSuggestions(false); // Hide the dropdown after selection
  };

  const handleRemoveRecipient = (index) => {
    const updatedRecipients = [...recipients];
    updatedRecipients.splice(index, 1);
    setRecipients(updatedRecipients);
  };
  const handleScroll = (indexToRemove) => {
    setIsDropdownOpen(false);
  };
  const handleInputChangeAddRecipient = (e) => {
    const value = e.target.value;
    setInputValue(value);
    // Filter suggestions based on the input value
    const filtered = suggestions.filter((suggestion) =>
      suggestion.toLowerCase().includes(value.toLowerCase()),
    );
    setFilteredSuggestions(filtered);
    setShowSuggestions(value.trim().length > 0);
  };
  const [selectedOption, setSelectedOption] = useState(null); // State to hold selected option

  const fromOptions = [
    {
      value: '1',
      label: 'John Daniel',
      role: 'Developer',
      image: '/avatar.svg',
    },
    {
      value: '2',
      label: 'Jane Smith',
      role: 'Designer',
      image: '/avatar.svg',
    },
    {
      value: '3',
      label: 'Mike Lee',
      role: 'Project Manager',
      image: '/avatar.svg',
    },
  ];

  const handleAddRecipientButton = () => {
    if (filteredSuggestions.includes(inputValue.trim())) {
      handleAddRecipient(inputValue.trim());
    }
  };
  const navigate = useNavigate();
  const location = useLocation();
  const [filter, setFilter] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const filterOptions = [
    { value: 10, label: '10' },
    { value: 20, label: '20' },
    { value: 30, label: '30' },
    { value: 50, label: '50' },
  ];

  const [preSelectedFilter, setpreSelectedFilter] = useState({
    value: 10,
    label: '10',
  });

  const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedCustomers([]); // Deselect all
    } else {
      setSelectedCustomers(customers.map((customer) => customer.id)); // Select all
    }
    setSelectAll(!selectAll); // Toggle Select All state
  };
  const removeUsers = async (e) => {
    e.preventDefault();
    try {
      const response = await DeleteUser();
      if (response.status == 200) {
        getCustomers();
        setSelectedCustomers([]);
        setSelectAll(false);
      } else {
        showToast(response.message, 'error');
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  const DeleteUser = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/user/delete`;
    const bodyData = {
      user_ids: selectedCustomers,
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'DELETE',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const getLocation = async (country, state, city) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/onboarding/location/ids`;

    let bodyData = {
      country: country,
      state: state,
      city: city,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const getAllLocationDetailsReg = async () => {
    try {
      const response = await getLocation(
        registeredAddress.country &&
          registeredAddress.country.name &&
          registeredAddress.country.name !== ''
          ? registeredAddress.country.name
          : registeredAddress.country,
        registeredAddress.state &&
          registeredAddress.state.name &&
          registeredAddress.state.name !== ''
          ? registeredAddress.state.name
          : registeredAddress.state,
        registeredAddress.city &&
          registeredAddress.city.name &&
          registeredAddress.city.name !== ''
          ? registeredAddress.city.name
          : registeredAddress.city,
      );
      setRegCountry(response.country_id);
      setRegState(response.state_id);
      setRegCity(response.city_id);
    } catch (err) {
      setRegCountry(null);
      setRegState(null);
      setRegCity(null);
      showToast(err.message, 'error');
    }
  };
  const postInviteAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let payloadRegAddress = {
      address_line_1:
        registeredAddress.street == ''
          ? registeredAddress.full
          : registeredAddress.street,
      address_line_2: registeredAddress.route,
      city_id: redRegCity,
      state_id: redRegState,
      country_id: redRegCountry,
      zip_code: registeredAddress.zip,
      google_address: registeredAddress.full,
    };
    if (payloadRegAddress.city_id === null) {
      showToast('Please enter valid address', 'error');
      return; // Stop execution if city_id is missing
    }
    const apiUrl = `${BASE_URL}/api/v1/business/agencies/invite`;
    const bodyData = {
      first_name: customerFirstName,
      last_name: customerLastName,
      email_address: email,
      mobile_number: mobileNumber,
      country_code: selectedCode,
      address: payloadRegAddress,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleAddAgency = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await postInviteAPI();
        if (response.status === 201) {
          getCustomers();
        }
      } catch (error) {
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [email, customerFirstName, customerLastName, selectedCode, mobileNumber], // Dependencies
  );
  const handleFilterChange = (selectedOption) => {
    console.log('Selected Option:', selectedOption);
    setpreSelectedFilter(selectedOption);
    setShowRecords(parseInt(selectedOption.value));
    setCurrentPage(1);
  };
  const toggleTableSelection = (customerId) => {
    setSelectedCustomers(
      (prevSelected) =>
        prevSelected.includes(customerId)
          ? prevSelected.filter((id) => id !== customerId) // Remove if already selected
          : [...prevSelected, customerId], // Add if not selected
    );
  };
  const headers = [
    { label: 'Name', key: 'first_name' },
    { label: 'Email', key: 'email_address' },
    { label: 'Status', key: 'status' },
    { label: 'Location', key: 'location' }, // No sorting for actions
    { label: 'Date & Time', key: 'created_at' }, // No sorting for actions
    { label: 'Action', key: '' },
  ];
  const reviewHeaders = [
    { label: 'Name', key: 'first_name' },
    { label: 'Email', key: 'email_address' },
    { label: 'Location', key: 'location' }, // No sorting for actions
    { label: 'Date & Time', key: 'created_at' }, // No sorting for actions
  ];
  const handleBlur = () => {};
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
          status: response.status,
        }));

        // Ensure errorData.message is extracted properly
        const errorMessage =
          typeof errorData === 'object' && errorData.message
            ? errorData.message
            : `Error ${response.status}: ${response.statusText}`;

        throw new Error(errorMessage);
      }

      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  function formatDateTime(dateString) {
    if (!dateString) return '-';

    try {
      // remove timezone abbreviations like AEDT, AEST etc.
      const cleaned = dateString.replace(/\b[A-Z]{3,4}\b/g, '').trim();

      const parts = cleaned.split(' ');
      const [day, month, year] = parts[0].split('/');

      let [hour, min, sec] = parts[1].split(':');
      const period = parts[2];

      hour = parseInt(hour);

      // convert 12h → 24h
      if (period === 'PM' && hour !== 12) hour += 12;
      if (period === 'AM' && hour === 12) hour = 0;

      return `${day}/${month}/${year} | ${hour
        .toString()
        .padStart(2, '0')}:${min}:${sec}`;
    } catch (e) {
      return '-';
    }
  }
  const handleSort = (key) => {
    setFilterText(key);
  };
  const formatNumber = (value) => {
    // Format number with commas and two decimal places
    return Number(value).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click happened outside all dropdowns
      const isOutside = !Object.values(buttonRefs.current).some((ref) =>
        ref?.contains(event.target),
      );

      if (isOutside) {
        setIsDropdownOpen(false); // Close dropdown if clicked outside
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);
  const unformatNumber = (value) => {
    // Remove commas from the formatted number
    return value.replace(/,/g, '');
  };

  const handleInputChange = (e) => {
    const rawValue = e.target.value; // Raw input value
    const numericValue = unformatNumber(rawValue); // Remove formatting

    if (!isNaN(numericValue)) {
      setStartAmount(numericValue); // Save the unformatted value
    }
  };
  const handleInputChangeEndAmount = (e) => {
    const rawValue = e.target.value; // Raw input value
    const numericValue = unformatNumber(rawValue); // Remove formatting

    if (!isNaN(numericValue)) {
      setEndAmount(numericValue); // Save the unformatted value
    }
  };

  const getCustomers = async () => {
    setIsLoading(true);
    const direction = sortConfig.direction === 'asc' ? 'desc' : 'asc';

    try {
      const response = await GetAPIcalls(
        filter == ''
          ? `/api/v1/business/agencies?search=${searchQuery}&page=${currentPage}&size=${showRecords}&sort_by=${filterText}&sort_order=${direction}`
          : `/api/v1/business/agencies?search=${searchQuery}&page=${currentPage}&size=${showRecords}&status=${filter}&sort_by=${filterText}&sort_order=${direction}`,
      );

      if (response.status == 200) {
        setCustomers(response.data.agencies);
        settotalPages(response.data.total_pages);
        setCurrentPage(response.data.page);
        settotalCount(response.data.total_count);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    } finally {
      setTimeout(function () {
        setIsLoading(false);
        setSortConfig({ key: null, direction });
      }, 100);
    }
  };
  const updateApplication = async (action, agencyId, reason) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl =
      action == 'block'
        ? `${BASE_URL}/api/v1/business/agencies/${agencyId}/block`
        : `${BASE_URL}/api/v1/business/agencies/${agencyId}/unblock`;
    const bodyData = {
      reason: reason,
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleUpdateApplication = useCallback(
    debounce(async (e, action, agentId, reason = null) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await updateApplication(action, agentId, reason);
        if (response.status == 200) {
          toastMessage = {
            message: response.message,
            type: 'success',
          };
          getCustomers();
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (error) {
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 1000); // Small delay if needed
        }
      }
    }, 1000),
    [reason], // Dependencies
  );
  const handleSelectInvestmentManagerAccount = (selectedOption) => {
    console.log('Selected Option:', selectedOption);
  };
  useEffect(() => {
    getCustomers();
  }, [searchQuery, currentPage, showRecords, filter, filterText]);
  useEffect(() => {
    dispatch(changeAgencyTabFalse());
  }, []);
  return (
    <div className="pt-4 p-2 lg:min-w-[78vw] lg:max-w-[80vw]">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div
        onScroll={handleScroll}
        className="pt-4  text-xs overflow-x-auto  flex-wrap items-center"
      >
        {roleName == 'business' && (
          <div className="flex mb-2 ">
            <button
              onClick={() => setFilter('')}
              className={`px-4 py-2 lg:w-20 rounded-l-xl border-r border-gray-100 ${
                filter === ''
                  ? 'bg-[#375AE7] text-white'
                  : 'bg-white text-black'
              }`}
            >
              All
            </button>
            <button
              onClick={() => setFilter('active')}
              className={`lg:px-4 px-2 py-2 border-r border-gray-100 ${
                filter === 'active'
                  ? 'bg-[#375AE7] text-white'
                  : 'bg-white text-black'
              }`}
            >
              Active
            </button>
            <button
              onClick={() => setFilter('suspended')}
              className={`px-4 py-2 border-r border-gray-100 ${
                filter === 'suspended'
                  ? 'bg-[#375AE7] text-white'
                  : 'bg-white text-black'
              }`}
            >
              Suspended
            </button>{' '}
            <button
              onClick={() => setFilter('blocked')}
              className={`px-4 py-2 rounded-r-xl ${
                filter === 'blocked'
                  ? 'bg-[#375AE7] text-white'
                  : 'bg-white text-black'
              }`}
            >
              Blocked
            </button>
          </div>
        )}
        {roleName == 'agency_compliance' && (
          <div className="flex mb-2 ">
            <button
              onClick={() => setFilter('')}
              className={`px-4 py-2 lg:w-20 rounded-l-xl border-r border-gray-100 ${
                filter === ''
                  ? 'bg-[#375AE7] text-white'
                  : 'bg-white text-black'
              }`}
            >
              All
            </button>
            <button
              onClick={() => setFilter('active')}
              className={`lg:px-4 px-2 py-2 border-r border-gray-100 ${
                filter === 'active'
                  ? 'bg-[#375AE7] text-white'
                  : 'bg-white text-black'
              }`}
            >
              Active
            </button>
            <button
              onClick={() => setFilter('onboarding')}
              className={`px-4 py-2  ${
                filter === 'onboarding'
                  ? 'bg-[#375AE7] text-white'
                  : 'bg-white text-black'
              }`}
            >
              Onboarding
            </button>
            <div className="relative">
              <button
                onClick={handlePendingClick}
                ref={(el) => (buttonRefs.current[`pending`] = el)}
                className={`flex items-center px-4 py-2 border-r border-gray-100 ${
                  filter === 'to_review' ||
                  filter === 'in_progress' ||
                  filter === 'sent_for_resubmit' ||
                  filter === 'sent_for_approval'
                    ? 'bg-[#375AE7] text-white'
                    : 'bg-white text-black'
                }`}
              >
                Pending
                <img
                  src={
                    filter === 'to_review' ||
                    filter === 'in_progress' ||
                    filter === 'sent_for_resubmit' ||
                    filter === 'sent_for_approval'
                      ? '/white-dropdown.svg'
                      : '/dropdown-down.svg'
                  }
                  alt="Dropdown Icon"
                  className="ml-2 w-2 h-2"
                />
              </button>
              <DropdownTest
                isOpen={isDropdownOpen}
                buttonRef={buttonRefs.current[`pending`]} // Pass unique ref to the dropdown
              >
                <div className="absolute mt-2 text-sm bg-white border border-gray-200 rounded-md shadow-lg w-40">
                  <ul className="text-left">
                    <li
                      onClick={() => {
                        setFilter('to_review');
                        setIsDropdownOpen(false);
                      }}
                      className={`px-4 py-2 hover:bg-[#375AE7] hover:text-white cursor-pointer ${
                        filter === 'to_review'
                          ? 'bg-[#375AE7] text-white'
                          : 'bg-white text-black'
                      }`}
                    >
                      To Review
                    </li>
                    <li
                      onClick={() => {
                        setFilter('in_progress');
                        setIsDropdownOpen(false);
                      }}
                      className={`px-4 py-2 hover:bg-[#375AE7] hover:text-white cursor-pointer ${
                        filter === 'in_progress'
                          ? 'bg-[#375AE7] text-white'
                          : 'bg-white text-black'
                      }`}
                    >
                      In Progress
                    </li>
                    <li
                      onClick={() => {
                        setFilter('sent_for_resubmit');
                        setIsDropdownOpen(false);
                      }}
                      className={`px-4 py-2 hover:bg-[#375AE7] hover:text-white cursor-pointer ${
                        filter === 'sent_for_resubmit'
                          ? 'bg-[#375AE7] text-white'
                          : 'bg-white text-black'
                      }`}
                    >
                      Sent for Resubmit
                    </li>
                    <li
                      onClick={() => {
                        setFilter('sent_for_approval');
                        setIsDropdownOpen(false);
                      }}
                      className={`px-4 py-2 hover:bg-[#375AE7] hover:text-white cursor-pointer ${
                        filter === 'sent_for_approval'
                          ? 'bg-[#375AE7] text-white'
                          : 'bg-white text-black'
                      }`}
                    >
                      Sent for Approval
                    </li>
                  </ul>
                </div>
              </DropdownTest>
            </div>
            <button
              onClick={() => setFilter('resubmit')}
              className={`px-4 py-2 border-r border-gray-100 ${
                filter === 'resubmit'
                  ? 'bg-[#375AE7] text-white'
                  : 'bg-white text-black'
              }`}
            >
              Resubmit
            </button>{' '}
            <button
              onClick={() => setFilter('suspended')}
              className={`px-4 py-2 border-r border-gray-100 ${
                filter === 'suspended'
                  ? 'bg-[#375AE7] text-white'
                  : 'bg-white text-black'
              }`}
            >
              Suspended
            </button>{' '}
            <button
              onClick={() => setFilter('archieved')}
              className={`px-4 py-2 rounded-r-xl ${
                filter === 'archieved'
                  ? 'bg-[#375AE7] text-white'
                  : 'bg-white text-black'
              }`}
            >
              Archive
            </button>
          </div>
        )}
      </div>
      {roleName != 'officer' && (
        <div className="w-full  p-4 bg-white rounded-lg shadow-lg  relative">
          <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
            <div className="flex items-center">
              <img
                src="/customer-black.svg"
                alt="Company Logo"
                className="mr-3"
              />
              <span className="font-medium lg:text-xl text-sm">
                Business Owner List
              </span>
            </div>
            {roleName == 'business' && (
              <div ref={addCustomerRef} className="flex items-center space-x-4">
                <div className="relative inline-block ">
                  <div
                    className="flex items-center justify-center gap-2 px-4 py-2 border border-[#375AE7] text-[#375AE7] rounded-xl cursor-pointer h-11 w-auto"
                    onClick={() => togglePopupAddCustomer()}
                  >
                    <img
                      src="/Plus.svg"
                      alt="document-download"
                      className="mr-2"
                    />
                    <span>Invite Business Owner</span>
                  </div>
                </div>
              </div>
            )}
          </div>
          {isOpenNewCustomer && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[40vh] max-h-screen overflow-y-auto">
                {/* Modal Header */}
                <div>
                  <div className="flex items-center justify-between mb-4">
                    <h2 className="text-lg font-medium text-center w-full">
                      Invite Business Owner
                    </h2>
                    <div className="flex justify-end">
                      <img
                        onClick={togglePopupAddCustomer}
                        src="/add.svg"
                        alt="Add"
                        className="w-10 h-10 cursor-pointer"
                      />
                    </div>
                  </div>
                  <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                    {/* Left Column */}
                    <div className="space-y-4 pt-4 px-4">
                      <div>
                        <label
                          htmlFor="finInstituition"
                          className="mb-1 text-sm text-labelColour"
                        >
                          First Name
                        </label>{' '}
                        <input
                          id="finInstituition"
                          type="text"
                          value={customerFirstName}
                          onChange={(e) => setCustomerFirstName(e.target.value)}
                          className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                          placeholder="John Daniel"
                        />
                      </div>
                      <div>
                        <label
                          htmlFor="finInstituition"
                          className="mb-1 mt-4 text-sm text-labelColour"
                        >
                          Mobile Number
                        </label>{' '}
                        <div className="flex  items-center">
                          <select
                            value={selectedCode}
                            onChange={handleCodeChange}
                            onFocus={() => setFocus(true)}
                            onBlur={() => setFocus(false)}
                            className={`w-40  appearance-none border text-black  appearance-none text-sm font-medium rounded-tl-md rounded-tr-none rounded-br-none rounded-bl-md h-[2.813rem]  ${
                              focus
                                ? 'border-black border-2'
                                : ' border-gray-300 '
                            } border-r-0   border  py-2 px-1 leading-tight focus:outline-none `}
                            placeholder="AU+61"
                          >
                            {countries.map((country) => (
                              <option
                                key={country.code}
                                value={country.dialCode}
                              >
                                {country.code} {country.dialCode}
                              </option>
                            ))}
                          </select>
                          <input
                            type="tel"
                            id="mobileNumber"
                            value={mobileNumber}
                            onFocus={() => setFocus(true)}
                            onBlur={() => setFocus(false)}
                            onChange={(e) => setMobileNumber(e.target.value)}
                            placeholder="Mobile Number"
                            className={`border text-black text-base font-medium rounded-tr-md rounded-tl-none rounded-bl-none rounded-br-md h-[2.813rem] p-2 ${
                              focus
                                ? 'border-black border-2'
                                : ' border-gray-300 '
                            } rounded-md focus:outline-none w-full border-l-0 appearance-none`}
                          />
                        </div>
                      </div>
                    </div>

                    {/* Center Column with Border */}
                    <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                      <div>
                        <label
                          htmlFor="finInstituition"
                          className="mb-1 text-sm text-labelColour"
                        >
                          Last Name
                        </label>{' '}
                        <input
                          id="finInstituition"
                          type="text"
                          value={customerLastName}
                          onChange={(e) => setCustomerLastName(e.target.value)}
                          className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                          placeholder="John Daniel"
                        />
                      </div>
                      <div className="mt-4">
                        <label
                          htmlFor="finInstituition"
                          className="mb-1 text-sm text-labelColour"
                        >
                          Email
                        </label>{' '}
                        <input
                          id="finInstituition"
                          type="text"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                          placeholder="John Daniel"
                        />
                      </div>
                    </div>

                    {/* Right Column */}
                    <div className="space-y-4 px-4 pt-4">
                      <div>
                        <label
                          htmlFor="finInstituition"
                          className="mb-1 text-sm text-labelColour"
                        >
                          Address
                        </label>{' '}
                        <AddressAutocomplete
                          value={registeredAddress?.full}
                          className="w-full"
                          onSelect={(addr) => {
                            setRegisteredAddress(addr);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                    <button
                      onClick={togglePopupAddCustomer}
                      className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        if (!validateEmail(email)) {
                          showToast('Please enter a valid email', 'error');
                          return;
                        }
                        if (!customerLastName) {
                          showToast('Please enter last name', 'error');
                          return;
                        }
                        if (
                          !validator.isMobilePhone(
                            selectedCode + mobileNumber,
                            'any',
                          )
                        ) {
                          showToast(
                            'Please enter valid mobile number',
                            'error',
                          );
                          return;
                        }
                        if (!customerFirstName) {
                          showToast('Please enter first name', 'error');
                          return;
                        }
                        if (!registeredAddress || !redRegCountry) {
                          showToast('Please enter valid address', 'error');
                          return;
                        }

                        setLoading(true);
                        handleAddAgency(e);
                      }}
                      className="px-6 py-2 rounded-lg bg-[#375AE7] text-white"
                    >
                      Send Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
            <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
              <div className="flex items-center space-x-2">
                <span className="lg:text-md  text-sm text-[#8C8C8C]">
                  Show Records
                </span>
                <Dropdown
                  label=""
                  options={filterOptions}
                  preselectedValue={preSelectedFilter}
                  onSelect={handleFilterChange}
                />
              </div>
              <div className="flex items-center">
                <div className="relative">
                  <input
                    type="text"
                    className="p-2 pl-6 text-sm border rounded-xl"
                    placeholder="Search Business Owner"
                    value={searchQuery}
                    onChange={(e) => {
                      setCurrentPage(1);
                      setSearchQuery(e.target.value);
                    }}
                  />
                  <span className="absolute left-2 top-3 text-gray-500">
                    {' '}
                    <img
                      src="/search-normal.svg"
                      alt="Company Logo"
                      className="mr-2"
                    />
                  </span>
                </div>
              </div>
            </div>
            <div className="flex flex-wrap gap-4 items-center">
              {/* Remove Button */}
              <div className="w-full sm:w-auto">
                <button
                  onClick={(e) => removeUsers(e)}
                  className="w-full sm:w-auto border bg-white text-black font-semibold border-gray-300 h-10 rounded-xl text-sm px-4 flex justify-between items-center focus:outline-none"
                >
                  <div className="flex items-center">
                    <img
                      src="/trash.svg"
                      alt="Remove Icon"
                      className="h-5 w-5 mr-2"
                    />
                    Remove
                  </div>
                </button>
              </div>
            </div>
          </div>
          <div>
            {/* Table */}
            <div className="overflow-x-auto">
              <table className="w-full h-full table-auto w-full border-separate border-spacing-y-4 border-spacing-x-0">
                {/* Table Header */}
                <thead className="text-[#8C8C8C] bg-[#F9F9F9] text-sm">
                  <tr className="mb-4">
                    <th
                      key="1"
                      className="cursor-pointer font-medium px-4 py-2 border rounded-l text-left"
                    >
                      <div className="flex items-center">
                        <input
                          type="checkbox"
                          id="selectUser"
                          checked={selectAll} // Bind to Select All state
                          onChange={toggleSelectAll} // Handle toggle
                          className="custom-checkbox h-3 w-3 mr-2"
                        />{' '}
                        <span>All</span>
                      </div>
                    </th>

                    {/* Dynamic Headers */}
                    {headers.map((header) => (
                      <th
                        onClick={() => handleSort(header.key)}
                        key={header.label}
                        className="cursor-pointer font-medium px-4 py-2  border text-left"
                      >
                        <div className="flex items-center justify-between w-full">
                          <span>{header.label}</span>
                          {header.label !== '' && (
                            <img
                              src="/sort.svg"
                              alt="Sort Icon"
                              className="w-4 h-4 ml-auto"
                            />
                          )}
                        </div>
                      </th>
                    ))}
                  </tr>
                </thead>

                {isLoading ? (
                  <tbody className="shimmer-container-list ">
                    {/* Creating 5 rows of shimmer effect */}
                    {[...Array(5)].map((_, rowIndex) => (
                      <tr key={rowIndex} className="shimmer-row-list">
                        {/* Creating 7 cells in each row for shimmer */}
                        {[...Array(10)].map((_, colIndex) => (
                          <td key={colIndex} className="shimmer-cell-list">
                            <div className="shimmer-loader"></div>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <tbody className="text-sm mt-4 font-medium text-black">
                    {customers.length > 0 ? (
                      <>
                        {customers.map((customer) => (
                          <tr key={customer.id} className="px-6 py-2 bg-white">
                            <td className="px-6 rounded-l border-r-0 border py-2">
                              <input
                                type="checkbox"
                                id="selectUser"
                                checked={selectedCustomers.includes(
                                  customer.id,
                                )} // Check if selected
                                onChange={() =>
                                  toggleTableSelection(customer.id)
                                }
                                className="custom-checkbox h-4 w-4 rounded"
                              />
                            </td>
                            <td
                              onClick={() => {
                                if (
                                  filter == 'active' ||
                                  customer.status.label == 'suspended' ||
                                  customer.status.label == 'archived' ||
                                  customer.status.label == 'active' ||
                                  filter == 'suspended' ||
                                  filter == 'archived'
                                ) {
                                  dispatch(
                                    setAgencyNameRedux(customer.full_name),
                                  );
                                  let redirectState = {
                                    path: `/agency-details/${customer.user_id}`,
                                    state: {
                                      from: location.pathname,
                                      historyStack: [
                                        ...(location.state?.historyStack || []),
                                        location.pathname,
                                      ],
                                    },
                                  };
                                  sessionStorage.setItem(
                                    'redirectAfterLogin',
                                    JSON.stringify(redirectState),
                                  );
                                  navigate(
                                    `/agency-details/${customer.user_id}`,
                                    {
                                      state: {
                                        from: location.pathname,
                                        historyStack: [
                                          ...(location.state?.historyStack ||
                                            []),
                                          location.pathname,
                                        ],
                                      },
                                    },
                                  );
                                }
                              }}
                              disabled={
                                !(
                                  filter == 'active' ||
                                  customer.status.label == 'active' ||
                                  customer.status.label == 'suspended' ||
                                  customer.status.label == 'archived' ||
                                  filter == 'suspended' ||
                                  filter == 'archived'
                                )
                              }
                              className={`${
                                filter == 'active' ||
                                customer.status.label == 'suspended' ||
                                customer.status.label == 'archived' ||
                                customer.status.label == 'active' ||
                                filter == 'suspended' ||
                                filter == 'archived'
                                  ? 'underline cursor-pointer'
                                  : ''
                              } px-4 py-6 border-b border-t text-left min-w-[200px] max-w-[auto] font-medium flex items-center space-x-2`}
                            >
                              <img
                                src="/avatar.svg"
                                className="w-8 h-8 rounded-full"
                              />
                              <span className="text-left">
                                {customer.full_name}
                              </span>
                            </td>
                            <td className="px-4 py-2 w-40 border-b border-t relative">
                              {customer.email_address}
                            </td>
                            <td className="px-4 w-20 border-b border-t text-center py-2">
                              <button
                                className={` w-40 text-center  font-medium h-10 rounded-xl text-xs px-2 py-2  flex justify-center items-center focus:outline-none${
                                  customer.status.label == 'active'
                                    ? ' text-[#34C046] bg-[#34C046] bg-opacity-20'
                                    : ''
                                }
                              ${
                                customer.status.label == 'onboarding'
                                  ? ' text-[#375AE7] bg-[#375AE7] bg-opacity-20'
                                  : ''
                              }
                                 ${
                                   customer.status.label == 'draft'
                                     ? ' text-[#375AE7] bg-[#375AE7] bg-opacity-20'
                                     : ''
                                 }
                            ${
                              customer.status.label == 'to_review'
                                ? ' text-[#F77E27] bg-[#F77E27] bg-opacity-20'
                                : ''
                            }
                                ${
                                  customer.status.label == 'in_progress'
                                    ? ' text-[#FFC421] bg-[#FFC421] bg-opacity-20'
                                    : ''
                                }
                                 ${
                                   customer.status.label == 'pending'
                                     ? ' text-[#FFC421] bg-[#FFC421] bg-opacity-20'
                                     : ''
                                 }
                                ${
                                  customer.status.label == 'resubmit'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                ${
                                  customer.status.label == 'sent_for_resubmit'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                ${
                                  customer.status.label == 'sent_for_approval'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                  ${
                                    customer.status.label == 'rejected'
                                      ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                      : ''
                                  }
                                    ${
                                      customer.status.label == 'blocked'
                                        ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                        : ''
                                    }
                                   ${
                                     customer.status.label == 'deleted'
                                       ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                       : ''
                                   }
                               ${
                                 customer.status.label == 'suspended'
                                   ? ' text-white bg-[#FF5050]'
                                   : ''
                               }
                               ${
                                 customer.status.label == 'closed'
                                   ? ' text-[#000000] bg-[#000000] bg-opacity-20'
                                   : ''
                               }
                                ${
                                  customer.status.label == 'archived'
                                    ? ' text-[#A6A6A6] bg-[#A6A6A6] bg-opacity-20'
                                    : ''
                                }
                              `}
                              >
                                <span className="mr-6 text-center">
                                  {customer.status.label
                                    .replace(/_/g, ' ')
                                    .replace(/\b\w/g, (char) =>
                                      char.toUpperCase(),
                                    )}
                                </span>
                              </button>
                            </td>
                            <td className="px-4 py-2 text-ellipsis overflow-hidden border-b border-t">
                              <div className="px-2">
                                <span>{customer.location.name}</span>
                              </div>
                            </td>
                            <td className="px-4 py-2 border-b border-t rounded-r border-l-0 text-ellipsis border overflow-hidden whitespace-nowrap">
                              <div className="flex items-center px-2 space-x-2">
                                <img
                                  src="/clock.svg"
                                  alt="Time Icon"
                                  className="h-4 w-4"
                                />
                                <span className="rounded-xl">
                                  {formatDateTimeUTC(customer.created_at)}
                                </span>
                              </div>
                            </td>
                            <td className="px-4 py-3 border-b border-t border-l-0 border rounded-r">
                              <div className="flex items-center gap-2">
                                {/* BLOCK */}
                                {customer.status?.label !== 'blocked' && (
                                  <button
                                    onClick={() => {
                                      setSelectedUserId(customer.user_id);
                                      setReason('');
                                      setError('');
                                      setShowBlockModal(true);
                                    }}
                                    className="
  group inline-flex items-center gap-1.5 rounded-full
  border border-slate-200 bg-white px-3.5 py-1.5
  text-xs sm:text-sm font-medium text-slate-700
  shadow-sm transition-all duration-200
  hover:border-[#375AE7] hover:text-[#375AE7]
  hover:bg-[#375AE7]/5 hover:shadow-md active:scale-95
  "
                                  >
                                    <Ban size={14} />
                                    Block
                                  </button>
                                )}

                                {/* UNBLOCK */}
                                {customer.status?.label === 'blocked' && (
                                  <button
                                    onClick={(e) => {
                                      setLoading(true);
                                      handleUpdateApplication(
                                        e,
                                        'unblock',
                                        customer.user_id,
                                      );
                                    }}
                                    className="
        group
        inline-flex
        items-center
        gap-1.5
        rounded-full
        border
        border-slate-200
        bg-white
        px-3.5
        py-1.5
        text-xs
        sm:text-sm
        font-medium
        text-slate-700
        shadow-sm
        transition-all
        duration-200
        hover:border-[#375AE7]
        hover:text-[#375AE7]
        hover:bg-[#375AE7]/5
        hover:shadow-md
        active:scale-95
        "
                                  >
                                    <RotateCcw
                                      size={14}
                                      className="transition-transform group-hover:scale-110"
                                    />
                                    Unblock
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <tr>
                        <td colSpan="8" className="py-6 text-center">
                          <div className="flex justify-center items-center">
                            No result found
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                )}
              </table>
            </div>

            {customers.length > 0 && (
              <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                {/* Entries Info Section */}
                <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                  Showing {showRecords * (currentPage - 1) + 1} to{' '}
                  {currentPage === totalPages || totalPages == 0
                    ? totalCount
                    : Math.max(
                        showRecords * currentPage,
                        customers.length,
                      )}{' '}
                  of {totalCount} entries
                </div>

                {/* Pagination Section */}
                <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                  {/* Previous Button */}
                  <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((prev) => prev - 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Prev
                  </button>

                  {/* Page Buttons */}
                  {Array.from({ length: Math.min(totalPages, 5) }).map(
                    (_, index) => {
                      const startPage = Math.max(
                        1,
                        Math.min(totalPages - 4, currentPage - 2),
                      );
                      const page = startPage + index;

                      return (
                        <button
                          key={page}
                          onClick={() => setCurrentPage(page)}
                          className={`px-3 py-1 rounded ${
                            currentPage === page
                              ? 'bg-[#375AE7] text-white'
                              : 'bg-white border border-gray-300 text-black'
                          }`}
                        >
                          {page}
                        </button>
                      );
                    },
                  )}

                  {/* Next Button */}
                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {roleName == 'agency_compliance' &&
        filter != 'invites' &&
        filter != 'to_review' &&
        filter !== 'sent_for_resubmit' &&
        filter !== 'pending' &&
        filter !== 'onboarding' &&
        filter !== 'in_progress' &&
        filter !== 'resubmit' &&
        filter !== 'sent_for_approval' && (
          <div className="w-full  p-4 bg-white rounded-lg shadow-lg  relative">
            <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
              <div className="flex items-center">
                <img
                  src="/customer-black.svg"
                  alt="Company Logo"
                  className="mr-3"
                />
                <span className="font-medium lg:text-xl text-sm">
                  Business Owner List
                </span>
              </div>
            </div>
            <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
              <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                <div className="flex items-center space-x-2">
                  <span className="lg:text-md  text-sm text-[#8C8C8C]">
                    Show Records
                  </span>
                  <Dropdown
                    label=""
                    options={filterOptions}
                    preselectedValue={preSelectedFilter}
                    onSelect={handleFilterChange}
                  />
                </div>
                <div className="flex items-center">
                  <div className="relative">
                    <input
                      type="text"
                      className="p-2 pl-6 text-sm border rounded-xl"
                      placeholder="Search Business Owner"
                      value={searchQuery}
                      onChange={(e) => {
                        setCurrentPage(1);
                        setSearchQuery(e.target.value);
                      }}
                    />
                    <span className="absolute left-2 top-3 text-gray-500">
                      {' '}
                      <img
                        src="/search-normal.svg"
                        alt="Company Logo"
                        className="mr-2"
                      />
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap gap-4 items-center">
                {/* Remove Button */}
                <div className="w-full sm:w-auto">
                  <button
                    onClick={(e) => removeUsers(e)}
                    className="w-full sm:w-auto border bg-white text-black font-semibold border-gray-300 h-10 rounded-xl text-sm px-4 flex justify-between items-center focus:outline-none"
                  >
                    <div className="flex items-center">
                      <img
                        src="/trash.svg"
                        alt="Remove Icon"
                        className="h-5 w-5 mr-2"
                      />
                      Remove
                    </div>
                  </button>
                </div>
              </div>
            </div>
            <div>
              {/* Table */}
              <div className="overflow-x-auto">
                <table className="w-full h-full table-auto w-full border-separate border-spacing-y-4 border-spacing-x-0">
                  {/* Table Header */}
                  <thead className="text-[#8C8C8C] bg-[#F9F9F9] text-sm">
                    <tr className="mb-4">
                      <th
                        key="1"
                        className="cursor-pointer font-medium px-4 py-2 border rounded-l text-left"
                      >
                        <div className="flex items-center">
                          <input
                            type="checkbox"
                            id="selectUser"
                            checked={selectAll} // Bind to Select All state
                            onChange={toggleSelectAll} // Handle toggle
                            className="custom-checkbox h-3 w-3 mr-2"
                          />{' '}
                          <span>All</span>
                        </div>
                      </th>

                      {/* Dynamic Headers */}
                      {headers.map((header) => (
                        <th
                          onClick={() => handleSort(header.key)}
                          key={header.label}
                          className="cursor-pointer font-medium px-4 py-2  border text-left"
                        >
                          <div className="flex items-center justify-between w-full">
                            <span>{header.label}</span>
                            {header.label !== '' && (
                              <img
                                src="/sort.svg"
                                alt="Sort Icon"
                                className="w-4 h-4 ml-auto"
                              />
                            )}
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>

                  {isLoading ? (
                    <tbody className="shimmer-container-list ">
                      {/* Creating 5 rows of shimmer effect */}
                      {[...Array(5)].map((_, rowIndex) => (
                        <tr key={rowIndex} className="shimmer-row-list">
                          {/* Creating 7 cells in each row for shimmer */}
                          {[...Array(10)].map((_, colIndex) => (
                            <td key={colIndex} className="shimmer-cell-list">
                              <div className="shimmer-loader"></div>
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  ) : (
                    <tbody className="text-sm mt-4 font-medium text-black">
                      {customers.length > 0 ? (
                        <>
                          {customers.map((customer) => (
                            <tr
                              key={customer.id}
                              className="px-6 py-2 bg-white"
                            >
                              <td className="px-6 rounded-l border-r-0 border py-2">
                                <input
                                  type="checkbox"
                                  id="selectUser"
                                  checked={selectedCustomers.includes(
                                    customer.id,
                                  )} // Check if selected
                                  onChange={() =>
                                    toggleTableSelection(customer.id)
                                  }
                                  className="custom-checkbox h-4 w-4 rounded"
                                />
                              </td>
                              <td
                                onClick={() => {
                                  if (
                                    filter == 'active' ||
                                    customer.status.label == 'suspended' ||
                                    customer.status.label == 'archived' ||
                                    customer.status.label == 'active' ||
                                    filter == 'suspended' ||
                                    filter == 'archived'
                                  ) {
                                    dispatch(
                                      setAgencyNameRedux(customer.full_name),
                                    );
                                    let redirectState = {
                                      path: `/agency-details/${customer.user_id}`,
                                      state: {
                                        from: location.pathname,
                                        historyStack: [
                                          ...(location.state?.historyStack ||
                                            []),
                                          location.pathname,
                                        ],
                                      },
                                    };
                                    sessionStorage.setItem(
                                      'redirectAfterLogin',
                                      JSON.stringify(redirectState),
                                    );
                                    navigate(
                                      `/agency-details/${customer.user_id}`,
                                      {
                                        state: {
                                          from: location.pathname,
                                          historyStack: [
                                            ...(location.state?.historyStack ||
                                              []),
                                            location.pathname,
                                          ],
                                        },
                                      },
                                    );
                                  }
                                }}
                                disabled={
                                  !(
                                    filter == 'active' ||
                                    customer.status.label == 'active' ||
                                    customer.status.label == 'suspended' ||
                                    customer.status.label == 'archived' ||
                                    filter == 'suspended' ||
                                    filter == 'archived'
                                  )
                                }
                                className={`${
                                  filter == 'active' ||
                                  customer.status.label == 'suspended' ||
                                  customer.status.label == 'archived' ||
                                  customer.status.label == 'active' ||
                                  filter == 'suspended' ||
                                  filter == 'archived'
                                    ? 'underline cursor-pointer'
                                    : ''
                                } px-4 py-6 border-b border-t text-left min-w-[200px] max-w-[auto] font-medium flex items-center space-x-2`}
                              >
                                <img
                                  src="/avatar.svg"
                                  className="w-8 h-8 rounded-full"
                                />
                                <span className="text-left">
                                  {customer.full_name}
                                </span>
                              </td>
                              <td className="px-4 py-2 w-40 border-b border-t relative">
                                {customer.email_address}
                              </td>
                              <td className="px-4 w-20 border-b border-t text-center py-2">
                                <button
                                  className={` w-40 text-center  font-medium h-10 rounded-xl text-xs px-2 py-2  flex justify-center items-center focus:outline-none${
                                    customer.status.label == 'active'
                                      ? ' text-[#34C046] bg-[#34C046] bg-opacity-20'
                                      : ''
                                  }
                              ${
                                customer.status.label == 'onboarding'
                                  ? ' text-[#375AE7] bg-[#375AE7] bg-opacity-20'
                                  : ''
                              }
                                 ${
                                   customer.status.label == 'draft'
                                     ? ' text-[#375AE7] bg-[#375AE7] bg-opacity-20'
                                     : ''
                                 }
                            ${
                              customer.status.label == 'to_review'
                                ? ' text-[#F77E27] bg-[#F77E27] bg-opacity-20'
                                : ''
                            }
                                ${
                                  customer.status.label == 'in_progress'
                                    ? ' text-[#FFC421] bg-[#FFC421] bg-opacity-20'
                                    : ''
                                }
                                 ${
                                   customer.status.label == 'pending'
                                     ? ' text-[#FFC421] bg-[#FFC421] bg-opacity-20'
                                     : ''
                                 }
                                ${
                                  customer.status.label == 'resubmit'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                ${
                                  customer.status.label == 'sent_for_resubmit'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                ${
                                  customer.status.label == 'sent_for_approval'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                  ${
                                    customer.status.label == 'rejected'
                                      ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                      : ''
                                  }
                                    ${
                                      customer.status.label == 'blocked'
                                        ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                        : ''
                                    }
                                   ${
                                     customer.status.label == 'deleted'
                                       ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                       : ''
                                   }
                               ${
                                 customer.status.label == 'suspended'
                                   ? ' text-white bg-[#FF5050]'
                                   : ''
                               }
                               ${
                                 customer.status.label == 'closed'
                                   ? ' text-[#000000] bg-[#000000] bg-opacity-20'
                                   : ''
                               }
                                ${
                                  customer.status.label == 'archived'
                                    ? ' text-[#A6A6A6] bg-[#A6A6A6] bg-opacity-20'
                                    : ''
                                }
                              `}
                                >
                                  <span className="mr-6 text-center">
                                    {customer.status.label
                                      .replace(/_/g, ' ')
                                      .replace(/\b\w/g, (char) =>
                                        char.toUpperCase(),
                                      )}
                                  </span>
                                </button>
                              </td>
                              <td className="px-4 py-2 text-ellipsis overflow-hidden border-b border-t">
                                <div className="px-2">
                                  <span>{customer.location.name}</span>
                                </div>
                              </td>
                              <td className="px-4 py-2 border-b border-t rounded-r border-l-0 text-ellipsis border overflow-hidden whitespace-nowrap">
                                <div className="flex items-center px-2 space-x-2">
                                  <img
                                    src="/clock.svg"
                                    alt="Time Icon"
                                    className="h-4 w-4"
                                  />
                                  <span className="rounded-xl">
                                    {formatDateTimeUTC(customer.created_at)}
                                  </span>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </>
                      ) : (
                        <tr>
                          <td colSpan="8" className="py-6 text-center">
                            <div className="flex justify-center items-center">
                              No result found
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  )}
                </table>
              </div>

              {customers.length > 0 && (
                <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                  {/* Entries Info Section */}
                  <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                    Showing {showRecords * (currentPage - 1) + 1} to{' '}
                    {currentPage === totalPages || totalPages == 0
                      ? totalCount
                      : Math.max(
                          showRecords * currentPage,
                          customers.length,
                        )}{' '}
                    of {totalCount} entries
                  </div>

                  {/* Pagination Section */}
                  <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                    {/* Previous Button */}
                    <button
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage((prev) => prev - 1)}
                      className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      Prev
                    </button>

                    {/* Page Buttons */}
                    {Array.from({ length: Math.min(totalPages, 5) }).map(
                      (_, index) => {
                        const startPage = Math.max(
                          1,
                          Math.min(totalPages - 4, currentPage - 2),
                        );
                        const page = startPage + index;

                        return (
                          <button
                            key={page}
                            onClick={() => setCurrentPage(page)}
                            className={`px-3 py-1 rounded ${
                              currentPage === page
                                ? 'bg-[#375AE7] text-white'
                                : 'bg-white border border-gray-300 text-black'
                            }`}
                          >
                            {page}
                          </button>
                        );
                      },
                    )}

                    {/* Next Button */}
                    <button
                      disabled={currentPage === totalPages}
                      onClick={() => setCurrentPage((prev) => prev + 1)}
                      className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      Next
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

      {roleName == 'agency_compliance' &&
        (filter == 'to_review' ||
          filter == 'pending' ||
          filter == 'onboarding' ||
          filter == 'in_progress' ||
          filter == 'resubmit' ||
          filter === 'sent_for_resubmit' ||
          filter === 'sent_for_approval') && (
          <div className="w-full  p-4 bg-white rounded-lg shadow-lg  relative">
            <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
              <div className="flex items-center">
                <img
                  src="/profile-black.svg"
                  alt="Company Logo"
                  className="mr-3"
                />
                <span className="font-medium lg:text-xl text-sm">
                  Review Business Owner List
                </span>
              </div>
            </div>
            <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
              <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                <div className="flex items-center space-x-2">
                  <span className="lg:text-md  text-sm text-[#8C8C8C]">
                    Show Records
                  </span>
                  <Dropdown
                    label=""
                    options={filterOptions}
                    preselectedValue={preSelectedFilter}
                    onSelect={handleFilterChange}
                  />
                </div>
                <div className="flex items-center">
                  <div className="relative">
                    <input
                      type="text"
                      className="p-2 pl-6 text-sm border rounded-xl w-full sm:w-80 md:w-96 lg:w-[420px]"
                      placeholder="Search Customer"
                      value={searchQuery}
                      onBlur={handleBlur}
                      onChange={(e) => {
                        setSearchQuery(e.target.value);
                        setCurrentPage(1);
                      }}
                    />
                    <span className="absolute left-2 top-3 text-gray-500">
                      {' '}
                      <img
                        src="/search-normal.svg"
                        alt="Company Logo"
                        className="mr-2"
                      />
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap gap-4 items-center">
                {/* Filter Button */}
                <div className="w-full sm:w-auto">
                  <button
                    onClick={togglePopup}
                    className="w-full sm:w-auto border bg-white text-black font-semibold border-gray-300 h-10 rounded-xl text-sm px-4 flex justify-between items-center focus:outline-none"
                  >
                    <div className="flex items-center">
                      <img
                        src="/filter-sort-black.svg"
                        alt="Filter Icon"
                        className="h-5 w-5 mr-2"
                      />
                      Filter
                    </div>
                  </button>
                </div>

                {/* Send Message Button */}
                <div className="w-full sm:w-auto">
                  <button
                    onClick={toggleSendMessagePopup}
                    className="w-full sm:w-auto border bg-white text-black font-semibold border-gray-300 h-10 rounded-xl text-sm px-4 flex justify-between items-center focus:outline-none"
                  >
                    <div className="flex items-center">
                      <img
                        src="/send-message.svg"
                        alt="Send Message Icon"
                        className="h-5 w-5 mr-2"
                      />
                      Send Message
                    </div>
                  </button>
                </div>
                {isSendMessageOpen && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="w-[90%] md:w-[50%] max-w-[700px] bg-[#F9F9F9] rounded-lg p-6 shadow-lg max-h-[90%] overflow-y-auto">
                      {/* Header */}
                      <div className="flex items-center justify-between mb-4">
                        <h2 className="text-lg text-center w-full font-semibold">
                          New Message
                        </h2>
                        <button onClick={toggleSendMessagePopup}>
                          <img
                            src="/add.svg"
                            alt="Close"
                            className="w-10 h-10"
                          />
                        </button>
                      </div>

                      <div className="w-full  p-4 bg-white rounded-lg shadow-lg">
                        {' '}
                        <div className="flex items-center mb-4 w-full w-full">
                          <label className="w-1/4 text-sm font-medium text-labelLightColour">
                            From:
                          </label>
                          <div className="w-3/4">
                            <div className="relative w-full md:w-full">
                              {/* Dropdown Button */}
                              <button
                                onClick={() => setToUser(!isToUser)}
                                className="w-full md:w-full border font-medium border-gray-300 h-10 rounded-xl text-sm px-2 py-2 pr-10 flex justify-between items-center focus:outline-none bg-white text-black"
                              >
                                <div className="flex items-center flex-grow">
                                  {/* Selected Image */}
                                  <img
                                    src={selectedOption?.image || '/avatar.svg'} // Display image from selected option or default image
                                    alt="User Icon"
                                    className="h-5 w-5 mr-2"
                                  />
                                  {/* Display selected name and role */}
                                  <div className="flex flex-col  md:flex-row truncate">
                                    {selectedOption ? (
                                      <>
                                        <span className="mr-2 truncate">
                                          {selectedOption.label}
                                        </span>
                                        <span className="text-[#375AE7] truncate">
                                          {selectedOption.role}
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        <span className="truncate">
                                          name here
                                        </span>
                                        <span className="text-[#375AE7] ml-2 truncate">
                                          onboarding
                                        </span>
                                      </>
                                    )}
                                  </div>
                                </div>
                                {/* Arrow (moved to the right) */}
                                <img
                                  src="/download-small-arrow.svg"
                                  alt="Arrow Icon"
                                  className="h-3 w-3 ml-auto md:ml-4 ml-3"
                                />
                              </button>

                              {/* Dropdown List */}
                              {isToUser && (
                                <div
                                  className="absolute left-0 mt-2 overflow-y-auto mb-5 w-full bg-white border rounded-md shadow-lg z-50"
                                  style={{
                                    maxHeight: '200px', // Optional: limit height
                                  }}
                                >
                                  {fromOptions.map((option) => (
                                    <div
                                      key={option.value}
                                      onClick={() => {
                                        setSelectedOption(option); // Set selected option when clicked
                                        setToUser(false); // Close dropdown
                                      }}
                                      className="px-4 py-2 font-medium hover:bg-[#375AE7] hover:text-white text-sm flex items-center cursor-pointer"
                                    >
                                      <img
                                        src={option.image}
                                        alt="Option Icon"
                                        className="h-5 w-5 mr-2"
                                      />
                                      <span>{option.label}</span>
                                      <span className="text-[#375AE7] ml-2">
                                        {option.role}
                                      </span>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* To Section */}
                        <div className="flex items-start mb-4">
                          <label className="w-1/4 text-sm font-medium text-labelLightColour">
                            To:
                          </label>
                          <div className="w-3/4 relative">
                            <div className="flex flex-wrap items-center gap-2 border border-gray-300 rounded-md px-3 py-2">
                              {recipients.map((recipient, index) => (
                                <span
                                  key={index}
                                  className="inline-flex items-center px-3 py-1 rounded-lg bg-[#3047EC] text-white  text-xs font-medium"
                                >
                                  <span className="underline">{recipient}</span>
                                  <button
                                    onClick={() => handleRemoveRecipient(index)}
                                    className="ml-2 bg-white rounded  hover:text-gray-700"
                                  >
                                    <img
                                      src="/cross-black.svg"
                                      alt="Arrow Icon"
                                      className="h-2 w-2 m-1 " // ml-auto pushes the arrow to the right
                                    />{' '}
                                  </button>
                                </span>
                              ))}
                              <input
                                type="text"
                                placeholder="Add recipient"
                                value={inputValue}
                                onChange={handleInputChangeAddRecipient} // Update input value on change
                                onKeyDown={(e) => {
                                  if (
                                    e.key === 'Enter' &&
                                    e.target.value.trim()
                                  ) {
                                    handleAddRecipientButton(); // Use validation on Enter
                                  }
                                }}
                                className="flex-1 text-sm focus:outline-none"
                              />
                              <button
                                onClick={handleAddRecipientButton} // Use validation on click
                                className="ml-auto px-2 py-0 bg-[#3047EC] text-white text-md rounded-md hover:bg-[#3047EC]"
                              >
                                +
                              </button>
                            </div>
                            {/* Suggestions Dropdown */}
                            {showSuggestions && inputValue && (
                              <div className="absolute top-full mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg z-10">
                                {filteredSuggestions.length > 0 ? (
                                  filteredSuggestions.map(
                                    (suggestion, index) => (
                                      <div
                                        key={index}
                                        onClick={() =>
                                          handleAddRecipient(suggestion)
                                        }
                                        className="px-3 py-2 cursor-pointer hover:bg-[#375AE7] hover:text-white text-sm text-gray-700"
                                      >
                                        {suggestion}
                                      </div>
                                    ),
                                  )
                                ) : (
                                  <div className="px-3 py-2 text-sm text-gray-500">
                                    No matches found
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                        {/* Subject */}
                        <div className="flex items-center mb-4">
                          <label className="w-1/4 text-sm font-medium text-labelLightColour">
                            Subject:
                          </label>
                          <input
                            type="text"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            placeholder="Subject goes here"
                            className="w-3/4 border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none"
                          />
                        </div>
                        {/* Message */}
                        <div className="flex items-start mb-4">
                          <label className="w-1/4 text-sm font-medium text-labelLightColour">
                            Message:
                          </label>
                          <textarea
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            placeholder="Type your message here..."
                            rows={5}
                            className="w-3/4  resize-none  max-h-[90%] overflow-y-auto border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none"
                          />
                        </div>
                      </div>
                      {/* Attachments */}
                      <div className="w-full  mt-4 p-4 bg-white rounded-lg shadow-lg">
                        <div className="flex items-center space-x-2 px-4">
                          <h1 className="text-md font-medium mb-2">
                            Attachments
                          </h1>
                        </div>
                        <div className="space-y-4">
                          <div className="flex flex-row">
                            <div
                              key={2}
                              className="p-4 w-full sm:w-2/4 rounded-md bg-gray-50 relative"
                            >
                              {/* Delete Icon */}
                              <button
                                onClick={() => console.log('Delete')}
                                className="absolute top-2 right-2 p-2"
                              >
                                <img
                                  src="/trash.svg" // Replace with your delete icon
                                  alt="Delete Icon"
                                  className="h-4 w-4"
                                />
                              </button>

                              <div className="flex items-center">
                                <div className="h-10 w-10 flex-shrink-0">
                                  <img
                                    src="/word-icon.svg"
                                    alt="Avatar Icon"
                                    className="h-10 w-10"
                                  />
                                </div>
                                <div className="ml-4">
                                  <p className="text-sm">
                                    <span className="font-medium">
                                      Customer Signature.doc
                                    </span>
                                  </p>
                                  <p className="text-xs mt-1 text-black flex items-center space-x-2">
                                    <span>22-01-2024 | 4.56 PM</span>
                                  </p>
                                  <p className="text-xs font-semibold text-black flex items-center space-x-2">
                                    <span>122.4 KB</span>
                                  </p>
                                </div>
                              </div>

                              {/* View Button */}
                              <div className="absolute bottom-2 right-0">
                                <button
                                  onClick={() => console.log('View')}
                                  className="px-4 py-2 text-black underline text-xs font-medium"
                                >
                                  View
                                </button>
                              </div>
                            </div>
                            <div
                              key={2}
                              onClick={toggleAddTemplatePopup}
                              className="p-4 ml-2 font-medium sm:w-1/3 md:w-20 rounded-md bg-[#F9F9F9] relative"
                            >
                              <div className="flex flex-col items-center">
                                <div className="flex-shrink-0">
                                  <img
                                    src="/Paperclip.svg"
                                    alt="Add Template Icon"
                                    className="h-4 w-4"
                                  />
                                </div>
                                <div>
                                  <p className="text-xs text-center">
                                    <span className="font-medium ">
                                      Add Template
                                    </span>
                                  </p>
                                </div>
                                {/* Will use when file is available */}
                                {/* <div className="p-6">
                              <h1 className="text-lg font-bold mb-4">
                                Upload and Preview a .docx File
                              </h1>
                              <input type="file" onChange={handleFileUpload} />

                              {isPopupOpen && selectedFile && (
                                <ViewDocumentPopup
                                  fileName={selectedFile.name}
                                  file={selectedFile}
                                  onClose={() => setPopupOpen(false)}
                                />
                              )}
                            </div> */}
                              </div>
                            </div>
                            {istemplateOpen && (
                              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                                <div className="w-[90%] md:w-[70%] max-w-screen bg-[#F9F9F9] rounded-lg p-6 shadow-lg max-h-[90%] overflow-y-auto">
                                  {/* Header */}
                                  <div className="flex items-center justify-between mb-4">
                                    <h2 className="text-lg text-center w-full font-semibold">
                                      Add Template
                                    </h2>
                                    <button onClick={toggleAddTemplatePopup}>
                                      <img
                                        src="/add.svg"
                                        alt="Close"
                                        className="w-10 h-10"
                                      />
                                    </button>
                                  </div>
                                  <div className="w-full  mt-4 p-4 bg-white rounded-lg shadow-lg">
                                    <div className="flex items-center space-x-2 px-4">
                                      <h1 className="text-md font-medium mb-2">
                                        Templates
                                      </h1>
                                    </div>
                                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                      {documents.map((doc) => (
                                        <div
                                          key={doc.id}
                                          className="p-4 w-full rounded-md bg-gray-50 relative"
                                        >
                                          {/* Delete Icon */}
                                          <button
                                            onClick={() => {
                                              setCurrentDoc(doc);
                                              setIsDocDelete(true);
                                            }}
                                            className="absolute top-2 right-2 p-2"
                                          >
                                            <img
                                              src="/trash.svg"
                                              alt="Delete Icon"
                                              className="h-4 w-4"
                                            />
                                          </button>

                                          {/* Document Details */}
                                          <div className="flex items-center">
                                            <div className="h-10 w-10 flex-shrink-0">
                                              <img
                                                src={doc.icon}
                                                alt="Document Icon"
                                                className="h-10 w-10"
                                              />
                                            </div>
                                            <div className="ml-4">
                                              <p className="text-sm">
                                                <span className="font-medium">
                                                  {doc.name}
                                                </span>
                                              </p>
                                              <p className="text-xs mt-1 text-black">
                                                {doc.date}
                                              </p>
                                              <p className="text-xs font-semibold text-black">
                                                {doc.size}
                                              </p>
                                            </div>
                                          </div>

                                          {/* Download Button */}
                                          <div className="absolute bottom-2 right-2">
                                            <button
                                              onClick={() =>
                                                console.log(
                                                  `Download ${doc.name}`,
                                                )
                                              }
                                              className="px-4 py-2 text-black underline text-xs font-medium"
                                            >
                                              Download
                                            </button>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                    {isDocDelete && (
                                      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                                        <div className="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
                                          <button className="absolute top-3 right-3 text-black text-xl font-bold">
                                            &times;
                                          </button>

                                          <div className="flex justify-center items-center mb-4">
                                            <div className="flex items-center justify-center">
                                              <img
                                                src="/delete-warning.svg"
                                                alt="Add Template Icon"
                                                className="h-10 w-10"
                                              />
                                            </div>
                                          </div>

                                          <h2 className="text-lg font-medium mb-2">
                                            Are you sure?
                                          </h2>
                                          <p className="text-sm text-black mb-4">
                                            Are you sure you want to remove{' '}
                                            <br />{' '}
                                            <span className="font-medium italic">
                                              {currentDoc.name}
                                            </span>{' '}
                                            file?
                                          </p>

                                          <div className="flex justify-center space-x-4">
                                            <button
                                              onClick={() => {
                                                setIsDocDelete(false);
                                              }}
                                              className="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
                                            >
                                              No
                                            </button>
                                            <button
                                              onClick={() => {
                                                setIsFileExisted(false);
                                              }}
                                              className="px-6 py-2 bg-[#375AE7] text-white rounded-full font-medium hover:bg-gray-800"
                                            >
                                              Yes
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  <div className="w-full  mt-4 p-4 bg-white rounded-lg shadow-lg">
                                    <div className="border-b pb-6 mb-6">
                                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-2 sm:space-y-0 px-4">
                                        {/* Heading */}
                                        <h1 className="text-md font-medium mb-2 sm:mb-0">
                                          File Upload
                                        </h1>

                                        {/* Actions: Search, Select All, Remove */}
                                        <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-2 space-y-2 sm:space-y-0 w-full sm:w-auto">
                                          <button className="flex items-center bg-[#375AE7] text-white  font-medium text-xs border border-[#375AE7] py-2 lg:px-4 px-1 rounded-xl">
                                            <img
                                              src="/Plus-white.svg"
                                              alt="Add Icon"
                                              className="mr-2 ml-2 h-3 w-3"
                                            />
                                            <span className="inline">
                                              Upload Files
                                            </span>
                                          </button>
                                        </div>
                                      </div>
                                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-2 sm:space-y-0 px-4">
                                        <label className="bg-[#FAFAFA] w-full border rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                                          <input
                                            type="file"
                                            id="fileUpload"
                                            onChange={handleFileChange}
                                            accept=".pdf,.png,.jpeg"
                                            className="hidden"
                                          />
                                          <img
                                            src="/folder-add.svg"
                                            alt="Success Icon"
                                            className="h-4 w-4"
                                          />{' '}
                                          <p className="mt-2 text-gray-500 text-sm">
                                            Drag & Drop or <br />
                                            <p className="underline">
                                              Click to Upload
                                            </p>
                                          </p>
                                        </label>
                                      </div>
                                      {isFileExisted && (
                                        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                                          <div className="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
                                            <button className="absolute top-3 right-3 text-black text-xl font-bold">
                                              &times;
                                            </button>

                                            <div className="flex justify-center items-center mb-4">
                                              <div className="flex items-center justify-center">
                                                <img
                                                  src="/warning-circle.svg"
                                                  alt="Add Template Icon"
                                                  className="h-10 w-10"
                                                />
                                              </div>
                                            </div>

                                            <h2 className="text-lg font-medium mb-2">
                                              Are you sure?
                                            </h2>
                                            <p className="text-sm text-black mb-4">
                                              Do you want to replace <br />
                                              <span className="font-medium italic">
                                                {file.name}
                                              </span>{' '}
                                              file?
                                            </p>

                                            <div className="flex justify-center space-x-4">
                                              <button
                                                onClick={() => {
                                                  setIsFileExisted(false);
                                                }}
                                                className="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
                                              >
                                                No
                                              </button>
                                              <button
                                                onClick={() => {
                                                  setnewFile(currentFile);
                                                  setIsFileExisted(false);
                                                }}
                                                className="px-6 py-2 bg-[#375AE7] text-white rounded-full font-medium hover:bg-gray-800"
                                              >
                                                Yes
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                      <div className="flex flex-col sm:flex-row sm:items-center text-sm pl-5 mt-2 w-full">
                                        {/* Save Uploads Checkbox */}
                                        <div className="flex items-center w-full sm:w-auto mb-2 sm:mb-0">
                                          <input
                                            type="checkbox"
                                            id="selectUser"
                                            className="custom-checkbox h-3 w-3 mr-2"
                                          />
                                          <span className="text-black">
                                            Save Uploads to File List
                                          </span>
                                        </div>
                                        {/* Filters Section */}
                                        <div className="flex flex-wrap mt-2 sm:mt-0 sm:mr-4 mr-0 sm:ml-auto space-x-2">
                                          <span className="bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                                            PNG
                                          </span>
                                          <span className="bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                                            JPEG
                                          </span>
                                          <span className="bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                                            PDF
                                          </span>
                                          <span className="bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                                            &#62; 10 MB
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-2 sm:space-y-0 px-4">
                                      {/* Heading */}
                                      <h1 className="text-md font-medium mb-2 sm:mb-0">
                                        File List
                                      </h1>

                                      {/* Actions: Search, Select All, Remove */}
                                      <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-2 space-y-2 sm:space-y-0 w-full sm:w-auto">
                                        {/* Search Box */}
                                        <div className="relative font-normal w-full sm:w-auto">
                                          <input
                                            type="text"
                                            className="w-full sm:w-auto p-2 pl-6 text-xs border rounded-xl focus:ring-2 focus:ring-blue-500"
                                            placeholder="Search Files"
                                            value={searchQuery}
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                              setCurrentPage(1);
                                              setSearchQuery(e.target.value);
                                            }}
                                          />
                                          <span className="absolute left-2 top-3 text-gray-500">
                                            <img
                                              src="/search-normal.svg"
                                              alt="Search Icon"
                                              className="mr-2"
                                            />
                                          </span>
                                        </div>

                                        {/* Select All Button */}
                                        <div className="flex items-center text-sm pl-2 w-full sm:w-auto">
                                          <input
                                            type="checkbox"
                                            id="selectUser"
                                            className="custom-checkbox h-3 w-3 mr-2"
                                          />
                                          <span className="text-[#888888]">
                                            Select All
                                          </span>
                                        </div>

                                        {/* Remove Button */}
                                        <div className="w-full sm:w-auto text-xs">
                                          <button className="w-full sm:w-auto border bg-white text-black font-medium border-gray-300 h-8 rounded-xl text-sm px-4 flex justify-center sm:justify-between items-center focus:outline-none">
                                            <div className="flex items-center">
                                              <img
                                                src="/trash.svg"
                                                alt="Remove Icon"
                                                className="h-3 w-3 mr-2"
                                              />
                                              Remove
                                            </div>
                                          </button>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 mt-2 gap-4">
                                      {documents.map((doc) => (
                                        <div
                                          key={doc.id}
                                          className="p-4 w-full rounded-md bg-[#F9F9F9] relative"
                                        >
                                          {/* Checkbox */}
                                          <div className="absolute top-2 left-2">
                                            <input
                                              type="checkbox"
                                              id="selectUser"
                                              className="custom-checkbox h-2 w-2 mr-2"
                                            />
                                          </div>

                                          {/* Delete Icon */}
                                          <button
                                            onClick={() =>
                                              console.log(`Delete ${doc.name}`)
                                            }
                                            className="absolute top-2 right-2 p-2"
                                          >
                                            <img
                                              src="/trash.svg"
                                              alt="Delete Icon"
                                              className="h-4 w-4"
                                            />
                                          </button>

                                          {/* Document Details */}
                                          <div className="flex items-center">
                                            <div className="h-10 w-10 flex-shrink-0">
                                              <img
                                                src={doc.icon}
                                                alt="Document Icon"
                                                className="h-10 w-10"
                                              />
                                            </div>
                                            <div className="ml-4">
                                              <p className="text-sm">
                                                <span className="font-medium">
                                                  {doc.name}
                                                </span>
                                              </p>
                                              <p className="text-xs mt-1 text-black">
                                                {doc.date}
                                              </p>
                                              <p className="text-xs font-semibold text-black">
                                                {doc.size}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                  <div className="flex justify-between font-medium text-sm items-center mt-6">
                                    <button
                                      onClick={toggleAddTemplatePopup}
                                      className="px-4 py-2 rounded-full bg-white text-black border-2 border-black "
                                    >
                                      Back
                                    </button>
                                    <button className="px-8 py-2 rounded-full bg-[#375AE7] text-white">
                                      Select (2)
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="flex text-sm pl-2 items-center">
                          <input
                            type="checkbox"
                            id="selectUser"
                            className="custom-checkbox h-3 w-3 mr-2"
                          />{' '}
                          <span>Include e-Signatures</span>
                        </div>
                      </div>

                      {/* Actions */}
                      <div className="flex justify-between font-medium text-sm items-center mt-6">
                        <button
                          onClick={toggleSendMessagePopup}
                          className="px-4 py-2 rounded-full bg-white text-black border-2 border-black "
                        >
                          Save Draft
                        </button>
                        <button className="px-8 py-2 rounded-full bg-[#375AE7] text-white">
                          Send
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {/* Remove Button */}
                <div className="w-full sm:w-auto">
                  <button
                    onClick={(e) => removeUsers(e)}
                    className="w-full sm:w-auto border bg-white text-black font-semibold border-gray-300 h-10 rounded-xl text-sm px-4 flex justify-between items-center focus:outline-none"
                  >
                    <div className="flex items-center">
                      <img
                        src="/trash.svg"
                        alt="Remove Icon"
                        className="h-5 w-5 mr-2"
                      />
                      Remove
                    </div>
                  </button>
                </div>
              </div>
            </div>
            <div>
              {/* Table */}
              <div className="overflow-x-auto">
                <table className="w-full h-full table-auto w-full border-separate border-spacing-y-4 border-spacing-x-0">
                  {/* Table Header */}
                  <thead className="text-[#8C8C8C] bg-[#F9F9F9] text-sm">
                    <tr className="mb-4">
                      <th
                        key="1"
                        className="cursor-pointer font-medium px-4 py-2 border rounded-l text-left"
                      >
                        <div className="flex items-center">
                          <input
                            type="checkbox"
                            id="selectUser"
                            checked={selectAll} // Bind to Select All state
                            onChange={toggleSelectAll} // Handle toggle
                            className="custom-checkbox h-3 w-3 mr-2"
                          />{' '}
                          <span>All</span>
                        </div>
                      </th>

                      {/* Dynamic Headers */}
                      {reviewHeaders.map((header) => (
                        <th
                          onClick={() => handleSort(header.key)}
                          key={header.label}
                          className="cursor-pointer font-medium px-4 py-2  border text-left"
                        >
                          <div className="flex items-center justify-between w-full">
                            <span>{header.label}</span>
                            {header.label !== '' && (
                              <img
                                src="/sort.svg"
                                alt="Sort Icon"
                                className="w-4 h-4 ml-auto"
                              />
                            )}
                          </div>
                        </th>
                      ))}
                      <th className="cursor-pointer font-medium px-4 py-2  border text-left">
                        <div className="flex items-center justify-between w-full">
                          <span></span>
                        </div>
                      </th>
                    </tr>
                  </thead>

                  {isLoading ? (
                    <tbody className="shimmer-container-list ">
                      {/* Creating 5 rows of shimmer effect */}
                      {[...Array(5)].map((_, rowIndex) => (
                        <tr key={rowIndex} className="shimmer-row-list">
                          {/* Creating 7 cells in each row for shimmer */}
                          {[...Array(10)].map((_, colIndex) => (
                            <td key={colIndex} className="shimmer-cell-list">
                              <div className="shimmer-loader"></div>
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  ) : (
                    <tbody className="text-sm mt-4 font-medium text-black">
                      {customers.map((customer) => (
                        <tr
                          key={customer.id}
                          className="px-6 py-2 bg-[#F9F9F9]"
                        >
                          <td className="px-6 rounded-l border-r-0 border py-2">
                            <input
                              type="checkbox"
                              id="selectUser"
                              checked={selectedCustomers.includes(customer.id)} // Check if selected
                              onChange={() => toggleTableSelection(customer.id)}
                              className="custom-checkbox h-4 w-4 rounded"
                            />
                          </td>
                          <td className="px-4 py-4 border-b border-t text-left min-w-[200px] max-w-[400px] font-medium flex items-center space-x-2">
                            <img
                              src="/avatar.svg"
                              className="w-8 h-8 rounded-full"
                            />
                            <span className="text-left">
                              {customer.type == 'Corporate'
                                ? customer.company_name
                                : customer.first_name +
                                  ' ' +
                                  customer.last_name}
                            </span>
                          </td>
                          <td className="px-4 py-2 text-ellipsis overflow-hidden border-b border-t">
                            <div className="px-2">
                              <span>{customer.location}</span>
                            </div>
                            <div className="px-2">
                              <span className="text-[#75E380]">Low</span>
                            </div>
                          </td>
                          <td className="px-4 py-2 border-b border-t  text-ellipsis overflow-hidden whitespace-nowrap">
                            <div className="flex items-center space-x-2">
                              <img
                                src="/clock.svg"
                                alt="Time Icon"
                                className="h-4 w-4"
                              />
                              <span className="rounded-xl">
                                {formatDateTimeUTC(customer.created_at)}
                              </span>
                            </div>
                          </td>
                          <td
                            onClick={() => {
                              dispatch(setOnboardingCustomer(customer.id));
                              let redirectState = {
                                path:
                                  customer.type == 'Individual'
                                    ? `/review-kyc/${customer.id}`
                                    : customer.type == 'Trust'
                                      ? `/review-kyc-trust/${customer.id}`
                                      : `/review-kyc-corporate/${customer.id}`,
                                state: {
                                  from: location.pathname,
                                  historyStack: [
                                    ...(location.state?.historyStack || []),
                                    location.pathname,
                                  ],
                                },
                              };
                              sessionStorage.setItem(
                                'redirectAfterLogin',
                                JSON.stringify(redirectState),
                              );
                              navigate(
                                customer.type == 'Individual'
                                  ? `/review-kyc/${customer.id}`
                                  : customer.type == 'Trust'
                                    ? `/review-kyc-trust/${customer.id}`
                                    : `/review-kyc-corporate/${customer.id}`,
                                {
                                  state: {
                                    from: location.pathname,
                                    historyStack: [
                                      ...(location.state?.historyStack || []),
                                      location.pathname,
                                    ],
                                  },
                                },
                              );
                            }}
                            className="px-4 py-2 border-b border-t rounded-r border-l-0 border   text-ellipsis  overflow-hidden whitespace-nowrap"
                          >
                            <span className="text-black bg-white px-2 py-2 cursor-pointer rounded-xl">
                              Review Application
                            </span>
                          </td>
                        </tr>
                      ))}{' '}
                    </tbody>
                  )}
                </table>
              </div>

              <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                {/* Entries Info Section */}
                <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                  Showing {showRecords * (currentPage - 1) + 1} to{' '}
                  {currentPage === totalPages || totalPages == 0
                    ? totalCount
                    : Math.max(
                        showRecords * currentPage,
                        customers.length,
                      )}{' '}
                  of {totalCount} entries
                </div>

                {/* Pagination Section */}
                <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                  {/* Previous Button */}
                  <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((prev) => prev - 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Prev
                  </button>

                  {/* Page Buttons */}
                  {Array.from({ length: Math.min(totalPages, 5) }).map(
                    (_, index) => {
                      const startPage = Math.max(
                        1,
                        Math.min(totalPages - 4, currentPage - 2),
                      );
                      const page = startPage + index;

                      return (
                        <button
                          key={page}
                          onClick={() => setCurrentPage(page)}
                          className={`px-3 py-1 rounded ${
                            currentPage === page
                              ? 'bg-[#375AE7] text-white'
                              : 'bg-white border border-gray-300 text-black'
                          }`}
                        >
                          {page}
                        </button>
                      );
                    },
                  )}

                  {/* Next Button */}
                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      {showBlockModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <div
            className="
      w-full max-w-md rounded-2xl bg-white p-6
      shadow-[0_20px_60px_-15px_rgba(0,0,0,0.25)]
      animate-in fade-in zoom-in-95
    "
          >
            {/* Header */}
            <h2 className="text-lg font-semibold text-slate-900">
              Confirm Block
            </h2>

            <p className="mt-1 text-sm text-slate-500">
              Please provide a reason for blocking this user.
            </p>

            {/* Textarea */}
            <textarea
              value={reason}
              maxLength={200}
              minLength={10}
              onChange={(e) => {
                setReason(e.target.value);
                if (e.target.value.length >= 10) setError('');
              }}
              placeholder="Enter reason (minimum 10 characters)..."
              className="
        mt-4 w-full rounded-xl border border-slate-200
        p-3 text-sm outline-none transition
        focus:border-[#375AE7] focus:ring-2 focus:ring-[#375AE7]/20
        "
              rows={4}
            />

            {/* Error */}
            {error && <p className="mt-2 text-xs text-red-500">{error}</p>}

            {/* Footer */}
            <div className="mt-5 flex justify-end gap-3">
              <button
                onClick={() => setShowBlockModal(false)}
                className="
          rounded-full border border-slate-200 px-4 py-2
          text-sm text-slate-600 hover:bg-slate-100
          "
              >
                Cancel
              </button>

              <button
                onClick={(e) => {
                  if (reason.trim().length < 10) {
                    setError('Reason must be at least 10 characters.');
                    return;
                  }

                  setLoading(true);
                  handleUpdateApplication(
                    e,
                    'block',
                    selectedUserId,
                    reason, // ✅ pass reason
                  );

                  setShowBlockModal(false);
                }}
                disabled={reason.trim().length < 10}
                className={`
          rounded-full px-4 py-2 text-sm font-medium text-white
          transition-all
          ${
            reason.trim().length >= 10
              ? 'bg-[#375AE7] hover:bg-[#2f4fd1]'
              : 'bg-slate-300 cursor-not-allowed'
          }
          `}
              >
                Confirm Block
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AgencyList;
